<div>
  <div bsModal #sendEmailModal="bs-modal" class="modal" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Send Email</h4>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label for="name">Available emails</label>
            <select [(ngModel)]="selectedEmail" class="form-control">
              <option *ngFor="let email of emails" [value]="email">{{ email }}</option>
            </select>
          </div>

          <br />

          <div style="text-align: right">
            <button type="button" class="btn aru btn-secondary" (click)="cancel()">Cancel</button>
            <button type="button" class="btn aru btn-primary" (click)="send()">Send email</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
